<template>
<div class="page page_book">
    <!-- 日历 -->
    <div class="selectDay">
        <van-cell title="请选择日期"></van-cell>
    </div>
    <!-- <div class="rili_more" @click="show=true"></div> -->
    <!-- <van-calendar v-model="show" :default-date="defaultDay" :show-confirm="false" class="rili" :formatter="formatter" :max-date="lastDay" :show-title="false" :show-subtitle="false" /> -->
    <!-- <van-calendar v-model="show" :default-date="defaultDay" :show-confirm="false" class="rili" :formatter="formatter" :show-title="true" :show-subtitle="true" @select="confirmDay" /> -->
    <van-tabs class="checkmonth" @click="checkmonth">
        <van-tab v-for="(item, key) in monthlist" :title="item.year + '年' + (item.month + 1) + '月'" :key="key"></van-tab>
    </van-tabs>
    <van-calendar :default-date="defaultDay" :poppable="false" :show-confirm="false" :min-date="dateBetween.minDate" :max-date="dateBetween.maxDate" class="checkcalendar" :formatter="calendarformatter" @select="confirmDay">
        <span slot="title" style="display:none;"></span>
    </van-calendar>
    <!-- 场次 门票-->
    <div class="book_info">
        <div class="book_title">场次</div>
        <div class="book_nr">
            <van-tabs v-model="active" :border="false" :ellipsis="false" @change="showActive" :lazy-render="false" class="changci-tabs">
                <van-tab v-for="item in todayTickets" :key="item.id" :name="item.id">
                    <template #title>
                        <div class="changci">{{ item.time_at }}</div>
                    </template>
                    <template #default>
                        <div class="nr">
                            <div class="nr_title">选择门票</div>
                            <div class="nr_item" v-for="ticket in item.ticket" :key="ticket.id">
                                <div class="nr_item_t clearfix">
                                    <div class="f-l">
                                        {{ ticket.title }}
                                        <div class="nr_item_t_desc">{{ ticket.describe }}</div>
                                    </div>
                                    <div class="f-r">{{ ticket.price ? '¥' + ticket.price : 0 }}</div>
                                </div>
                                <div class="nr_item_b clearfix">
                                    <div class="f-l">余票：{{ ticket.store }}</div>
                                    <div class="f-r adjustSku">
                                        <van-stepper @change="changePiaoNum($event, ticket.id, ticket.price)" :default-value="0" 
                                        v-model="ticket.num"
                                        :max="ticket.store" min="0" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>

                </van-tab>
                <!-- <van-tab name="b">
                    <template #title>
                        <div class="">9:00</div>
                    </template>
                    <div class="nr">
                        <div class="nr_title">选择门票</div>
                        <div class="nr_item">
                            <div class="nr_item_t clearfix">
                                <div class="f-l ">成人票</div>
                                <div class="f-r">¥200.00</div>
                            </div>
                            <div class="nr_item_b clearfix">
                                <div class="f-l">余票：99</div>
                                <div class="f-r adjustSku">
                                    <van-stepper v-model="value" />
                                </div>
                            </div>
                        </div>
                    </div>
                </van-tab> -->
            </van-tabs>
        </div>
        <!-- 购票须知 -->
        <div class="notice" @click="notice_pop = true">购票须知</div>
    </div>
    <!-- 接待人 -->
    <div class="fuwu" v-if="receper.length != 0">
        <div class="fuwu_title">接待人</div>
        <!-- <van-checkbox-group v-model="receper_id">
            <van-cell-group>
                <van-cell class="fuwu_info page_pay" v-for="(item, index) in receper" :key="index" @click="checkReceper(item)">
                    <template #title>
                        <span class="title">{{ item.name }}</span>
                    </template>
                    <template #right-icon>
                        <van-checkbox :name="item.id" ref="recepercheckboxes" disabled>
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                            </template>
                        </van-checkbox>
                    </template>
                </van-cell>
            </van-cell-group>
        </van-checkbox-group> -->
        <!-- 单选 -->
        <van-radio-group v-model="receper_id">
            <van-cell-group>
                <van-cell class="fuwu_info page_pay" v-for="(item, index) in receper" :key="index" @click="checkReceper(item)">
                    <template #title>
                        <span class="title">{{ item.name }}</span>
                    </template>
                    <template #right-icon>
                        <van-radio :name="item.id" ref="recepercheckboxes" disabled>
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                            </template>
                        </van-radio>
                    </template>
                </van-cell>
            </van-cell-group>
        </van-radio-group>
    </div>
    <!-- 附加服务 -->
    <div class="fuwu" v-if="service.length != 0">
        <div class="fuwu_title">附加服务</div>
        <van-checkbox-group v-model="serviceArr" @change="selectService">
            <van-cell-group>
                <van-cell class="fuwu_info page_pay" v-for="(item, index) in service" :key="index">
                    <!--  @click="toggle(index)" -->
                    <template #title>
                        <span class="title" @click="showServiceDetail(item)">{{ item.name }}</span>
                    </template>
                    <template #right-icon>
                        <span class="cash">¥{{ item.prices }}</span>
                        <van-checkbox :name="item.id" ref="checkboxes">
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                            </template>
                        </van-checkbox>
                    </template>
                </van-cell>
            </van-cell-group>
        </van-checkbox-group>
    </div>
    <!-- 填写联系方式等信息 -->
    <div class="fuwu fill">
        <div class="fuwu_info" @click="enterinfoStatus = true;" v-if="enterinfo.length != 0">
            <div class="fuwu_info_l">填写基本信息</div>
            <div class="fuwu_info_r">
                <div class="fuwu_info_r" v-if="fillEnterinfo">已填写</div>
                <img :src="this.publicPath + 'statics/images/icon_right_grey.png'" alt="" class="icon_arrow" />
            </div>
        </div>
        <div class="fuwu_info">
            <div class="fuwu_info_l">联络方式</div>
            <div class="fuwu_info_r">
                <van-field v-model="phone" placeholder="请您填写联络方式..." class="enterinfoField" />
            </div>
        </div>
    </div>
    <!-- 填写备注 -->
    <div class="fuwu page_baocuo">
        <div class="filed">
            <div class="">备注</div>
            <van-field v-model="mark" type="textarea" rows="1" placeholder="请您填写备注信息..." />
        </div>
    </div>
    <!-- 购票协议条款 -->
    <div class="agreement page_pay">
        <div class="select">
            <van-checkbox v-model="agreement">
                <template #icon="props">
                    <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template>
            </van-checkbox>
        </div>
        <div class="text">
            我已同意“
            <span class="agree_text" @click="goSinglePage(8)">购票服务协议条款</span>
            ”
        </div>
    </div>
    <!-- 底部购买 -->
    <div class="bottom">
        <div class="bottom_l">
            共{{ nums ? nums : 0 }}张，合计：
            <span class="price">
                <span class="tag_cash">¥</span>
                {{ piaoTotalPrice + fuwuTotalPrice }}
            </span>
        </div>
        <div class="bottom_r" @click="toBuy">立即购买</div>
    </div>
    <!-- 购票须知 -->
    <van-popup v-model="notice_pop" round position="bottom" close-icon="close" :closeable="true" class="addPop">
        <div class="pop_title">购票须知</div>
        <div class="pop_nr" v-html="notice">
        </div>
    </van-popup>
    <!-- 附加服务详情 -->
    <van-popup v-model="serviceDetailStatus" round position="bottom" class="addPop" close-icon="close" :closeable="true">
        <div class="pop_title">{{ serviceDetail != null ? serviceDetail.name : '' }}</div>
        <div class="pop_nr">
            {{ serviceDetail != null ? serviceDetail.descript : '' }}
        </div>
    </van-popup>
    <!-- 填写基本信息 -->
    <!-- <van-popup v-model="enterinfoStatus" round position="bottom" class="addPop" close-icon="close" :closeable="true" :close-on-click-overlay="false">
        <div class="pop_title">填写基本信息</div>
        <div class="pop_nr">
            <van-cell-group>
                <van-cell v-for="(item,key) in enterinfo" class="cellenterInfo">
                    <van-field v-model="item.value" :label="item.key" :placeholder="'请输入'+item.key" required class="enterinfoField" />
                </van-cell>
            </van-cell-group>
        </div>
    </van-popup> -->
    <van-popup v-model="enterinfoStatus" round position="bottom" class="addPop" close-icon="close" :closeable="false" :close-on-click-overlay="false">
        <div class="pop_title">
            <div class="">填写基本信息</div>
            <div class="close" @click="closeEnterinfo">取消</div>
            <div class="confirm" @click="confirmEnterinfo">确认</div>
        </div>
        <div class="pop_nr">
            <van-cell-group>
                <van-cell v-for="(item,key) in enterinfo" :key="key" class="cellenterInfo">
                    <van-field v-model="item.value" :label="item.key" :placeholder="'请输入'+item.key" required class="enterinfoField" />
                </van-cell>
            </van-cell-group>
        </div>
    </van-popup>
</div>
</template>

<script>
import router from '../../../.././router';
import {
    LOGOUT,
    LOGIN
} from '../../../.././vuex/mutation_types';
import PageSearch from '../../../component/search/Index.vue';
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js';
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: 'home-index',
    data() {
        return {
            publicPath: process.env.BASE_URL,
            id: null,
            lastDay: null,
            active: 'a',
            // value: 0, // 步进器的值
            checked: true,
            activeIcon: process.env.BASE_URL + 'statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + 'statics/images/inactive.png',
            mark: '', // 备注
            agreement: true,
            checkMonthsStatus: true, // 选择年月显示、隐藏
            date_ats: null, // 全部的购票信息
            enterinfo: [], // 基本信息/ 入场信息
            enterinfoStatus: false, // 基本信息 弹窗状态
            phone: '', // 联络方式
            service: [], // 附加服务
            serviceDetailStatus: false, // 附加服务详情弹窗
            serviceDetail: null, // 附加服务内容；
            receper: [], // 接待人信息
			// receper_id: [], // 选中的接待人id
			receper_id: null, // 选中的接待人id 单选
            todayTickets: [
                // {id:1,ticket:[{id:5,store:10}]},
                // {id:2,ticket:[{id:6,store:10}]},
            ], // 所有日期的票信息
            defaultDay: null, // 默认日期
            date: null, // 日期
            serviceArr: [], // 所选服务
            ticket_id: null, // 门票ID
            nums: null, // 购票数量
            defaultTickets: [], // 默认的票
            piaoTotalPrice: 0, // 购票费用
            fuwuTotalPrice: 0, // 服务费用
            totalPrice: 0, // 总费用
            notice_pop: false, // 购票须知
            notice: '', // 购票须知
            dateBetween: {
                minDate: new Date(),
                maxDate: new Date()
            },
            checkedMonth: null, // 当前选中的月；
            monthlist: [], // 可选月份
            fillEnterinfo: false // 是否已填写基本信息
        };
    },
    components: {
        PageSearch
    },
    created: function () {
        console.log(this.$route.query);
        // 获取最后一天
        this.getLastDay();
        //测试token
        // this.$store.commit(LOGIN, {
        //     token: 'JdkjGWTfej6fLzhzukVfrw==',
        // });
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                data: {
                    naviTitle: '约看预订',
                }
            };
            this.$bridge.callhandler('sdjy://navigation/style', params, data => {});
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data);
            });
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                        this.getData()
                    } else {
                        this.token = "";
                    }
                }
            );
        } else {
            this.token = this.$store.getters.token;
        }
        // 初始化当前月日历
        let nowYear = new Date().getFullYear();
        let nowMonth = new Date().getMonth();
        this.getMinMaxDate(new Date(nowYear, nowMonth, 1), new Date(nowYear, nowMonth, this.getCountDays(new Date(nowYear, nowMonth, 1))));

        // 设置可选择月份
        let monthlist = [];
        for (var i = 0; i < 2; i++) {
            if (nowMonth + i > 11) {
                monthlist.push({
                    id: i,
                    year: nowYear + 1,
                    month: nowMonth + i - 11
                });
            } else {
                monthlist.push({
                    id: i,
                    year: nowYear,
                    month: nowMonth + i
                });
            }
        }
        this.monthlist = monthlist;
    },
    mounted() {
        this.id = this.$route.query.id;
        let m = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
        this.checkedMonth = new Date().getFullYear() + '-' + m;
        this.getData();
    },
    methods: {
        getData() {
            var params = {
                id: this.id,
                month: this.checkedMonth
            };
            this.$api.live.bookeSpecs(params).then(res => {
                var arr = [];
                if (res.code == 200) {
                    var today = new Date(this.formatDate(new Date()) + ' 00:00:00');
                    this.date_ats = res.result.date_ats;
                    this.enterinfo = [];
                    this.notice = res.result.notice; // 购票须知
                    for (var i in res.result.enterinfo) {
                        this.enterinfo.push({
                            key: res.result.enterinfo[i].name,
                            value: ''
                        });
                    } // 基本信息/ 入场信息
                    console.log('this.enterinfo', this.enterinfo)
                    // 服务
                    this.service = res.result.service;

                    // 接待人
                    this.receper = res.result.receper;
                    console.log(this.receper)
                    // 设置默认
                    this.defaultDay = new Date(this.checkedMonth + '-' + 1) > today ? new Date(this.checkedMonth + '-' + 1) : today; // 类型 date
                    console.log('this.defaultDay', this.defaultDay)
                    this.date = this.defaultDay; // 类型 string
                    console.log('date', this.date)
                    this.todayTickets = this.findPiao(this.date, this.date_ats);
                    // 查找最早有票信息
                    for (var i in this.date_ats) {
                        for (var j in this.date_ats[i]) {
                            var day = new Date(this.date_ats[i][j].date_at);
                            // console.log('日期比较=========',day , today,'--------',day.getTime() , today.getTime(), day.getTime() >= today.getTime());
                            if (day >= today) {
                                // 取有效日期 今天之前不能购买
                                // console.log('只显示有效日期')
                                // console.log(this.date_ats[i][j])
                                // 返回有效日期的第一天
                                this.defaultDay = new Date(this.date_ats[i][j].date_at); // 类型 date
                                this.date = this.formatDate(new Date(this.date_ats[i][j].date_at)); // 类型 string
                                console.log('查找最早有票信息date', this.date, '----before---', this.date_ats[i][j].date_at)
								if(this.date.split('-')[1] == this.checkedMonth.split('-')[1]){
									this.todayTickets = this.findPiao(this.date, this.date_ats);
								}else{
									this.todayTickets = [];
								}
                                // console.log('todayTickets');
                                // console.log(this.todayTickets);
                                // console.log('active:', this.active);
                                return;
                            }
                        }
                    }
                }
            });
        },
        // 查选中的这一天的票信息
        findPiao(date, dateArr) {
            for (var i in dateArr) {
                if (date == i) {
                    var changci = dateArr[i]
                    for (let i = 0; i < changci.length; i++) {
                        const tickets = changci[i].ticket;
                        for (let j = 0; j < tickets.length; j++) {
                            const t = tickets[j];
                            t.num = 0
                        }
                    }
                    return changci;
                }
            }
            return [];
        },
        // 日历数据格式化
        calendarformatter(day) {
            // console.log('day',day)
            const year = day.date.getFullYear();
            const month = day.date.getMonth() + 1 < 10 ? '0' + (day.date.getMonth() + 1) : day.date.getMonth() + 1;
            const date = day.date.getDate() < 10 ? '0' + day.date.getDate() : day.date.getDate();
            const d = year + '-' + month + '-' + date;
            // 有票 
            for (var i in this.date_ats) {
                if (i == d) {
                    day.className = 'colorRed';
                    day.bottomInfo = '有票'; //this.date_ats[i].title;
                    return day;
                }
            }
            day.className = 'colorGrey';
            day.bottomInfo = '无票';
            return day;
            // if (month === 5) {
            //     if (date === 1) {
            //         day.topInfo = '劳动节';
            //     } else if (date === 4) {
            //         day.topInfo = '青年节';
            //     } else if (date === 11) {
            //         day.text = '今天';
            //     }
            // }

            // if (day.type === 'start') {
            //     day.bottomInfo = '入住';
            // } else if (day.type === 'end') {
            //     day.bottomInfo = '离店';
            // }

        },
        // 日期格式化函数
        // formatter(day) {
        //     // console.log(day)
        //     let date = day.date;
        //     // let date = day.date.getDay(); // 周几
        //     // this.formatDate(date)
        //     for (var i in this.date_ats) {
        //         if (this.formatDate(date) == i && day.type != 'disabled') {
        //             day.className = 'colorRed';
        //             day.bottomInfo = '有票';
        //         } else if (this.formatDate(new Date()) != i) {
        //             day.className = 'colorGrey';
        //             day.bottomInfo = '无票';
        //         } else {
        //             day.className = 'colorGrey';
        //             day.bottomInfo = '无票';
        //         }
        //     }
        //     // 周六日
        //     // if (date == 6 && day.type != 'disabled' || date == 0 && day.type != 'disabled') {
        //     //     day.className = 'colorRed'
        //     // }
        //     // console.log(date)
        //     return day;
        // },
        formatDate(date) {
            var year = date.getFullYear();
            var month = (date.getMonth() + 1).toString();
            var day = date.getDate().toString();
            if (month.length == 1) {
                month = '0' + month;
            }
            if (day.length == 1) {
                day = '0' + day;
            }
            return `${year}-${month}-${day}`;

            // return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        },
        // 选择月份
        checkmonth(name, title) {
            console.log('checkmonth');
            console.log(name, title, this.monthlist);
            let m = this.monthlist[name].month + 1 < 10 ? '0' + (this.monthlist[name].month + 1) : this.monthlist[name].month + 1;
            let tMonth = this.monthlist[name].year + '-' + m;
            this.checkedMonth = tMonth;
            this.getMinMaxDate(new Date(this.monthlist[name].year, this.monthlist[name].month, 1), new Date(this.monthlist[name].year, this.monthlist[name].month, this.getCountDays(new Date(this.monthlist[name].year, this.monthlist[name].month, 1))));
            this.getData();
        },
        // 监听 场次变化
        showActive(name, title) {
            console.log('showActive', name, title)
        },
        getMinMaxDate(min, max) {
            if (min < new Date()) {
                min = new Date();
            }
            this.dateBetween.minDate = min;
            this.dateBetween.maxDate = max;
        },
        // 返回本月多少天
        getCountDays(date) {
            var curDate = date; // new Date();
            /* 获取当前月份 */
            var curMonth = curDate.getMonth();
            /*  生成实际的月份: 由于curMonth会比实际月份小1, 故需加1 */
            curDate.setMonth(curMonth + 1);
            /* 将日期设置为0, 这里为什么要这样设置, 我不知道原因, 这是从网上学来的 */
            curDate.setDate(0);
            /* 返回当月的天数 */
            return curDate.getDate();
        },
        // 当前月最后一天
        getLastDay() {
            var date = new Date(),
                y = date.getFullYear(),
                m = date.getMonth();
            var firstDay = new Date(y, m, 1);
            var lastDay = new Date(y, m + 1, 0);
            console.log(lastDay);
            this.lastDay = lastDay;
        },
        // 点选某一天时,判断当天是否有票
        confirmDay(date) {
            // console.log('date', date)
            // console.log('date')
            // console.log(this.formatDate(date))
            var day = this.formatDate(date);
            var res = this.compare(day, this.date_ats);
            this.todayTickets = this.findPiao(day, this.date_ats);
            if (res) {
                this.date = res;
                // this.active = this.todayTickets[0].id;
            } else {
                this.date = null;
                this.$toast('请重新选择');
            }
            // console.log('todayTickets',this.todayTickets)
            // console.log('todayTickets=================1',this.todayTickets[0])
            console.log('res');
            console.log(res);
        },
        // 对比
        compare(item, arr) {
            for (var i in arr) {
                if (item == i) {
                    // console.log('compare',arr[i])
                    return item;
                }
            }
            return false;
        },
        // 选择接待人
        // selectReceper(arr) {
        //     console.log('选择接待人');
        //     console.log(arr);
        //     this.receper_id = arr;
        //     var price = 0;
        //     for (var i in this.receper) {
        //         for (var j in arr) {
        //             if (arr[j] == this.receper[i].id) {
        //                 price += this.receper[i].prices;
        //             }
        //         }
        //     }
        // },
        checkReceper(arr) {
            console.log('选择接待人');
			console.log(arr);
			// console.log(this.receper_id)
			
			if(this.receper_id != arr.id){
				this.receper_id = arr.id
			}else{
				this.receper_id = null
			}
            // for (var i in this.receper_id) {
            //     if (arr.id == this.receper_id[0]) {
            //         this.receper_id = [];
            //         return;
            //     }
            // }
            // this.receper_id = [arr.id];

        },
        // 扩大选择区域
        toggle(index) {
            this.$refs.checkboxes[index].toggle();
        },
        // 选择服务
        selectService(arr) {
            console.log('选择服务');
            console.log(arr);
            this.serviceArr = arr;
            var price = 0;
            for (var i in this.service) {
                for (var j in arr) {
                    if (arr[j] == this.service[i].id) {
                        price += this.service[i].prices;
                    }
                }
            }
            console.log('price');
            console.log(price);
            this.fuwuTotalPrice = price;
        },
        // 展示附加服务详情
        showServiceDetail(item) {
            this.serviceDetail = item;
            this.serviceDetailStatus = true;
        },
        // 改变步进器 一种票的情况(问一下是不是只有一种票)
        changePiaoNum(nums, id, price) {
            if (nums == 0) {
                return
            }
            console.log('id:',id);
            // console.log(typeof id)
            // console.log(typeof nums)
            var nnn = nums
            console.log(nnn);
            var todayTickets = this.todayTickets
            for (let i = 0; i < todayTickets.length; i++) {
                const tickets = todayTickets[i];
                for (let j = 0; j < tickets.ticket.length; j++) {
                    const t = tickets.ticket[j];
                    if (t.id != id) {
                        t.num = 0
                    } else {
                        console.log(nums);
                        t.num = nums
                    }
                }
                console.log(tickets)
            }
            this.todayTickets = todayTickets
            console.log(nnn);
            this.ticket_id = id;
            this.nums = nnn;

            var piaoTotalPrice = null;
            if (nnn) {
                piaoTotalPrice = nnn * price;
            }
            this.piaoTotalPrice = piaoTotalPrice;
        },
        // 购买
        toBuy() {
            var that = this
            // 未选任何票
            if (!this.ticket_id) {
                this.$toast('请您选择门票');
                return;
            }
            // 未同意协议
            if (!this.agreement) {
                this.$toast('请勾选购票服务协议');
                return;
            }
            // 如果接口 有返回基本信息填写
            let newEnterInfo = [];
            for (var i in this.enterinfo) {
                if (this.enterinfo[i].value == "") {
                    this.$toast('请完善基本信息');
                    this.enterinfoStatus = true;
                    return;
                }
                let ei = {};
                ei[this.enterinfo[i].key] = this.enterinfo[i].value;
                newEnterInfo.push(ei);
            }
            let phone = this.phone.replace(/(^\s+)|(\s+$)/g, "");
            if (phone == '') {
                this.$toast('请填写联络方式');
                return;
            } else if (!(/^1[3456789]\d{9}$/.test(phone))) {
                this.$toast('请填写合法的联络方式');
                return;
            }
            newEnterInfo.push({
                phone: phone
            });

            console.log('newEnterInfo', newEnterInfo);
            var params = {
                token: that.token,
                ticket_id: this.ticket_id,
                nums: this.nums,
                // services: this.serviceArr,
                enterinfo: newEnterInfo,
                // mark: this.mark
            };
            // 服务
            if (this.serviceArr.length != 0) {
                params.services = this.serviceArr
            }
            // 接待人
            // if (this.receper_id.length != 0) {
            //     params.receper_id = this.receper_id
			// }
			if (this.receper_id) {
                params.receper_id = this.receper_id
            }
            // params.receper_id = this.receper_id.length > 0 ? this.receper_id[0] : null;
            // console.log('this.receper_id',this.receper_id)
            // // 备注
            if (this.mark) {
                params.mark = this.mark;
            }
            console.log('params', params);
            this.$api.live.createorder(params).then(res => {
                console.log(res);
                if (res.code == 200) {
                    that.$toast(res.message);
                    that.$router.push({
                        path: '/yuekan/pay',
                        query: {
                            orderId: res.result.order_num,
                            price: res.result.total_prices,
							is_chargecard: res.result.live.is_chargecard
                        }
                    })
                }
            }).catch(err => {
                console.log('提交约看订单', err);
            })
        },
        // 协议  1 平台服务协议;2 供应商入驻协议;3 匠人入驻协议; 4 帮助中心 ; 5合伙人入驻协议; 6 代理商入驻协议 7.提现规则 8.购票协议
        goSinglePage(id) {
            this.$router.push({
                path: '/single/page',
                query: {
                    id: id
                }
            })
        },
        // 关闭 填写基本信息
        closeEnterinfo() {
            this.enterinfoStatus = false
        },
        // 确认 基本信息
        confirmEnterinfo() {
            for (var i in this.enterinfo) {
                if (this.enterinfo[i].value == "") {
                    this.$toast('请完善基本信息');
                    this.enterinfoStatus = true;
                    return;
                }
            }
            this.enterinfoStatus = false
            this.fillEnterinfo = true
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.rili {
    height: 7.68rem;
}

/deep/.colorRed {
    color: #D34444 !important;
}

/deep/.van-calendar__selected-day {
    color: rgba(0, 0, 0, 1);
    background: rgba(0, 0, 0, 0.05);
    width: 1.2rem;
    height: 1.2rem;
}

/deep/.colorRed .van-calendar__selected-day {
    color: #D34444 !important;
}

/deep/.van-calendar__day {
    height: 1.2rem;
    font-size: 0.4rem;
}

/deep/.van-calendar__month-title {
    display: none;
}

/deep/.van-calendar__weekday {
    font-size: 0.4rem;
    color: rgba(0, 0, 0, 0.87);
}

/deep/.van-calendar__header {
    box-shadow: none;
    margin-top: 0.2rem;
}

/deep/.colorGrey {
    color: #c8c9cc;
}

/deep/.van-calendar__selected-day {
    border-radius: 0.13rem;
    justify-content: space-between;
    flex-direction: column;
}

/deep/.van-calendar__day {
    margin-bottom: 0.2rem;
    flex-direction: column;
    justify-content: space-between;
}

/deep/.van-calendar__bottom-info {
    font-size: 0.29rem;
    line-height: normal;
    bottom: 0.05rem;
}

/deep/.fuwu_info {
    padding: .25rem;
}

/deep/.enterinfoField .van-field__control {
    color: #000;
}

/deep/.enterinfoField .van-cell__title span {
    vertical-align: sub;
    padding-left: .14rem;
}

/deep/.enterinfoField.van-cell--required::before {
    line-height: 1rem;
    left: 0;
}
/deep/.van-radio__icon{
	width: 0.53rem;
    height: 0.53rem;
    line-height: normal;
}
/deep/.changci-tabs .van-tabs__wrap{
	height: auto !important;
	padding: .2rem .53rem !important;
}
/deep/.changci-tabs .van-tabs__nav{
	flex-wrap: wrap;
}
/deep/.changci-tabs .van-tab{
	display: inline;
	padding: 0.2rem .4rem 0 0;
	flex: none;
}
</style>
